
        export * from 'react-dom/client.js';
        export * as default from 'react-dom/client.js'
        